//extracted by mini-css-extract-plugin
export default {"languageInputs":"PreferredLanguage_languageInputs__8lMiO","langInpChild":"PreferredLanguage_langInpChild__Yxblf"};;